import { setSvgIconSize } from 'components/Luxkit/SvgIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'
import ProductPaletteProvider from 'contexts/ProductPaletteContext'
import { rem } from 'polished'
import React, { ReactElement, ReactNode } from 'react'
import styled from 'styled-components'

const Container = styled(Group)`
  padding: ${rem(12)};
  border-radius: ${props => props.theme.borderRadius.S};
  background: var(--background);
  color: var(--contrast);

  &.tier-bronze {
    --background: ${props => props.theme.palette.product.loyalty.bronze.gradientSecondaryBackground};
    --contrast: ${props => props.theme.palette.product.loyalty.bronze.normalContrast};
    --icon-background: ${props => props.theme.palette.product.loyalty.bronze.darkBackground};
    --icon-contrast: ${props => props.theme.palette.product.loyalty.bronze.darkContrast};
    --alt-contrast: ${props => props.theme.palette.product.loyalty.bronze.lightContrast};
  }
  &.tier-silver {
    --background: ${props => props.theme.palette.product.loyalty.silver.gradientSecondaryBackground};
    --contrast: ${props => props.theme.palette.product.loyalty.silver.normalContrast};
    --icon-background: ${props => props.theme.palette.product.loyalty.silver.darkBackground};
    --icon-contrast: ${props => props.theme.palette.product.loyalty.silver.darkContrast};
    --alt-contrast: ${props => props.theme.palette.product.loyalty.silver.lightContrast};
  }
  &.tier-gold {
    --background: ${props => props.theme.palette.product.loyalty.gold.gradientSecondaryBackground};
    --contrast: ${props => props.theme.palette.product.loyalty.gold.normalContrast};
    --icon-background: ${props => props.theme.palette.product.loyalty.gold.darkBackground};
    --icon-contrast: ${props => props.theme.palette.product.loyalty.gold.darkContrast};
    --alt-contrast: ${props => props.theme.palette.product.loyalty.gold.lightContrast};
  }
  &.tier-platinum {
    --background: ${props => props.theme.palette.product.loyalty.platinum.gradientSecondaryBackground};
    --contrast: ${props => props.theme.palette.product.loyalty.platinum.darkContrast};
    --icon-background: ${props => props.theme.palette.product.loyalty.platinum.normalBackground};
    --icon-contrast: ${props => props.theme.palette.product.loyalty.platinum.darkContrast};
    --alt-contrast: ${props => props.theme.palette.product.loyalty.platinum.darkContrast};
  }
`

const IconContainer = styled.div`
  background-color: var(--icon-background);
  display: grid;
  place-items: center;
  height: ${rem(32)};
  width: ${rem(32)};
  border-radius: ${props => props.theme.borderRadius.round};
  color: var(--icon-contrast);
  flex-shrink: 0;
  ${setSvgIconSize(20)}

  &:empty { display: none; }
`

const Content = styled(Group)`
  flex-grow: 1;
`

const Title = styled(BodyText)`
  color: var(--contrast);
`

const Subtitle = styled(BodyText)`
  color: var(--alt-contrast);
`

interface Props {
  tier: App.LoyaltyTier;
  icon?: React.ReactNode;
  end?: React.ReactNode;
  subtitle?: React.ReactNode;
  children: string | ReactElement | Iterable<ReactNode>;
}

function LoyaltyTierCallOutBanner({
  tier,
  icon,
  end,
  subtitle,
  children,
}: Props) {
  return <ProductPaletteProvider palette={`tier-${tier}`}>
    <Container
      className={`tier-${tier}`}
      direction="horizontal"
      verticalAlign="center"
      gap={8}
    >
      {!!icon && <IconContainer>
        {icon}
      </IconContainer>}
      <Content direction="horizontal" horizontalAlign="space-between" wrap="wrap" gap={8}>
        <div>
          <Title variant="large" weight="bold">{children}</Title>
          {!!subtitle && <Subtitle variant="small">{subtitle}</Subtitle>}
        </div>
      </Content>
      {!!end && <div>{end}</div>}
    </Container>
  </ProductPaletteProvider>
}

export default LoyaltyTierCallOutBanner
